import React, { useEffect, useRef } from 'react';

/**
 * PageTransition - wraps page content with fade + slide-up entrance animation.
 * Usage: wrap the return of any page component with <PageTransition>...</PageTransition>
 */
export default function PageTransition({ children, className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref?.current;
    if (!el) return;
    el?.classList?.remove('page-enter');
    // Force reflow
    void el?.offsetWidth;
    el?.classList?.add('page-enter');
  }, []);

  return (
    <div ref={ref} className={`page-enter ${className}`}>
      {children}
    </div>
  );
}
